<template>
    <div class="pr-6 border-0 border-b md:border-0 border-solid border-gray-300 pb-6 md:pb-0">
        <div class="ds-text-sm uppercase font-bold text-gray-800 mt-4 mb-3">
            Description
        </div>

        <div v-if="description">{{description}}</div>
        <div v-else class="ds-text-sm italic text-gray-800">This video has no description.</div>
    </div>
</template>

<script>
    export default {
        props: {
            video: { type: Object, required: true },
        },
        
        computed: {
            description() {
                return this.video.description
            }
        }
    }
</script>